<template>
  <transition-group
    ref="group"
    :tag="tag"
    class="transition-group-fade"
    name="group-fade"
    move-class="group-fade-move"
    appear
    @enter="enter"
    @leave="leave">
    <slot v-if="!intersect || ( intersect && intersected )"></slot>
  </transition-group>
</template>

<script>
import { TweenMax } from "gsap";

export default {
  props: {
    tag: {
      type: String,
      default: "div",
    },
    intersect: {
      type: Boolean,
      default: false,
    },
    hideLeaveTransition: {
      type: Boolean,
      default: false,
    },
    entranceDelay: {
      type: Number,
      default: 0.3,
    },
    entranceDelayOffset: {
      type: Number,
      default: 0.1,
    },
  },
  data: () => ( {
    observer: null,
    intersected: false,
  } ),
  mounted () {
    if ( this.intersect ) {
      this.observer = new IntersectionObserver( this.onIntersect );
      this.observer.observe( this.$refs.group.$el );
    }
  },
  methods: {
    onIntersect ( [entry] ) {
      if ( entry.intersectionRatio > 0 ) {
        this.observer.unobserve( entry.target );
        this.intersected = true;
      }
    },
    enter ( el, done ) {
      const delay = ( el.dataset.index * this.entranceDelayOffset ) + this.entranceDelay;

      el.style.opacity = 0;
      TweenMax.killTweensOf( el );

      TweenMax.fromTo(
        el,
        0.8,
        {
          y: -20,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          delay,
          onComplete: done,
        },
      );
    },
    leave ( el, done ) {
      TweenMax.killTweensOf( el );

      if ( this.hideLeaveTransition ) {
        done();
      } else {
        TweenMax.to(
          el,
          0.2,
          { opacity: 0, onComplete: done },
        );
      }
    },
  },
};
</script>
